/**
 * Intended to be a helper to create, reading and/or remove cookies
 */
export class CookieUtils {

	/**
	 *
	 * @param name its the value to look for
	 * @returns string if the cookie is found otherwise null
	 */
	public static get(name: string): string | null {
		const nameLen = (name.length + 1);
		return document.cookie
			.split(';')
			.map(c => c.trim())
			.filter(cookie => {
				return cookie.substring(0, nameLen) === `${name}=`;
			})
			.map(cookie => {
				return decodeURIComponent(cookie.substring(nameLen));
			})[0] || null;
	}

	/**
	 * This will set the cookie 'max-age'  attribue to 0
	 * @param name will be the name of the cookie to be deleted
	 */
	public static delete(name: string): void {
		document.cookie = name + '=; max-age=0';
	}

}
